import { PageContainer, ProTable } from '@ant-design/pro-components';
import { queryTraceCommentLogs } from '../services/trace';

const columns = [
  {
    title: '组织ID',
    dataIndex: 'organizationId',
    copyable: true,
  },
  {
    title: '账号类型',
    dataIndex: 'accountType',
  },
  {
    title: '平台',
    dataIndex: 'platform',
  },
  {
    title: '账号ID',
    dataIndex: 'accountId',
    copyable: true,
  },
  {
    title: '内容ID',
    dataIndex: 'contentId',
    copyable: true,
  },
  {
    title: '评论ID',
    dataIndex: 'commentId',
    copyable: true,
  },
  {
    title: '评论用户',
    dataIndex: 'userName',
  },
  {
    title: '评论内容',
    dataIndex: 'content',
    ellipsis: true,
  },
  {
    title: '获赞数',
    dataIndex: 'likeCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '评论时间',
    dataIndex: 'createdAt',
    valueType: 'dateTime',
    search: false,
  },
];

const CommentLogs = () => (
  <PageContainer content="厂商管理员在这里查看评论维度的监测日志。">
    <ProTable
      rowKey="id"
      headerTitle="评论日志"
      request={queryTraceCommentLogs}
      columns={columns}
      search={{
        labelWidth: 96,
      }}
      scroll={{
        x: 'max-content',
      }}
    />
  </PageContainer>
);

export default CommentLogs;
